import Layout from '@/views/layout/Layout'

const flowRouter = {
  path: '/flow',
  component: Layout,
  redirect: 'noredirect',
  name: 'Flow',
  meta: { title: '信息管理', icon: 'flow-outline', roles: [2, 3, 4, 5,9,10,11,12,13] },
  children: [
    {
      path: 'product-flow',
      name: 'ProductFlow',
      component: () => import('@/views/flow/ProductFlow'),
      meta: { title: '商品流向', icon: 'product-flow-outline', roles: [2] }
    },
    {
      path: 'store-detail',
      name: 'StoreDetail',
      component: () => import('@/views/flow/StoreDetail'),
      meta: { title: '库存明细', icon: 'store-detail-outline', roles: [3] }
    },
    {
      path: 'product-info',
      name: 'ProductInfo',
      component: () => import('@/views/flow/ProductInfo'),
      meta: { title: '商品资料', icon: 'product-info-outline', roles: [4] }
    },
    {
      path: 'product-flow-price',
      name: 'ProductFlowPrice',
      component: () => import('@/views/flow/ProductFlowPrice'),
      meta: {
        title: '商品流向（单价）',
        icon: 'product-flow-price-outline',
        roles: [5]
      }
    },
    {
      path: 'product-flow2',
      name: 'ProductFlow2',
      component: () => import('@/views/flow/ProductFlow2'),
      meta: { title: '商品流向（物流）', icon: 'product-flow-outline', roles: [9] }
    },
    {
      path: 'store-detail2',
      name: 'StoreDetail2',
      component: () => import('@/views/flow/StoreDetail2'),
      meta: { title: '库存明细（物流）', icon: 'store-detail-outline', roles: [10] }
    },
    {
      path: 'product-flow-price2',
      name: 'ProductFlowPrice2',
      component: () => import('@/views/flow/ProductFlowPrice2'),
      meta: {
        title: '商品流向（单价-物流）',
        icon: 'product-flow-price-outline',
        roles: [11]
      }
    },
    {
      path: 'dzjgm-query',
      name: 'dzjgmQuery',
      component: () => import('@/views/flow/DzjgmQuery'),
      meta: { title: '电子监管码', icon: 'product-flow-outline', roles: [6] }
    },
    {
      path: 'product-flow-import',
      name: 'flowimport',
      component: () => import('@/views/flow/FlowImport'),
      meta: { title: '流向导入', icon: 'product-flow-price-outline', roles: [12] }
    },
    {
      path: 'product-add',
      name: 'productAdd',
      component: () => import('@/views/flow/ProductAdd'),
      meta: { title: '资料录入', icon: 'product-flow-price-outline', roles: [13] }
    },
  ]
}

export default flowRouter
